export const environment = {
  production: true,
  API_URL: 'https://api-login-qa.agunsa.com/',
  V1: 'v1/',
  RECAPTCHA_KEY: '6LdGPAsjAAAAACBkVj1e3uPRcfSN7QlCHFvM1vd5',
  CONTEXT: 'torre-de-control',
  WEB_URL: 'https://torrecontrol-qa.agunsa.com/',
  BACKEND_API_KEY: '0918374e-497d-47d2-a52e-7ccb8805ca92'
};
